import script from "./ChangeNameRh.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangeNameRh.vue?vue&type=script&setup=true&lang=js"

import "./ChangeNameRh.vue?vue&type=style&index=0&id=8f46546e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f46546e"]])

export default __exports__